import { Button } from "@carbon/react";

import { Select, TextInput } from "../../../ui";
import { SectionHeader } from "../../../components";

export const View = (props) => {
  return (
    <div className="onboarding-section">
      <SectionHeader
        title="We would like to know more about your business."
        subtitle="SwitchApp collects this information to verify your identity and keep your account safe."
      />

      <h5 className="form-section--title font-ctm--bold">Business Details</h5>

      <TextInput disabled={!props.isActive} />

      <TextInput disabled={!props.isActive} />

      <Select disabled={!props.isActive} />

      <Select disabled={!props.isActive} />

      <Select disabled={!props.isActive} />

        {!props.isActive ? null : (
          <Button
            className="switchapp-themed onboarding-submit--button "
            onClick={props.onSubmit}
          >
            Continue
          </Button>
        )}
      </div>
   
  );
};
